import {types} from './types';

const initialState = {
    replenishment: {
        data: [],
        countPage: 1
    },
}

export function replenishmentReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_REPLENISHMENT:
            return { ...state, replenishment: action.payload};
        default:
            return state
    }
}